import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferenceMaterialIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.97158 5.59987C7.4039 4.03476 5.30023 2.67063 3.00063 2.32437C2.34007 2.23951 1.8612 2.69265 1.73069 3.32492C1.07472 6.50281 1.08286 9.58631 1.73069 12.7642C1.82706 13.237 2.19209 13.7217 2.72214 13.7749C4.24917 13.9628 6.16704 14.9224 7.41474 15.7378C7.68129 15.9121 7.84975 16.0975 7.99896 16.2617C8.25124 16.5392 8.44844 16.7562 8.97158 16.7562C9.49854 16.7562 9.69718 16.5392 9.9513 16.2617C10.1016 16.0975 10.2713 15.9121 10.5398 15.7378C11.7966 14.9224 13.7284 13.9628 15.2666 13.7749C15.8005 13.7217 16.1682 13.237 16.2652 12.7642C16.9178 9.58631 16.926 6.50281 16.2652 3.32492C16.1337 2.69265 15.6514 2.23951 14.9861 2.32437C14.3978 2.4123 13.8224 2.56585 13.2652 2.77167",
			stroke: "currentColor",
			strokeWidth: 1.29,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.97144 5.5979V16.7543C10.0429 14.6757 11.0509 12.8788 12.7667 11.3805C13.2311 10.9749 13.3713 10.4947 13.4193 10.107C13.7421 7.50255 13.4067 4.74853 13.2311 2.22246C13.1689 1.32686 12.7928 0.949358 12.0952 1.51081C11.211 2.22246 9.96919 3.53359 8.97144 5.5979Z",
			stroke: "currentColor",
			strokeWidth: 1.29,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.97144 16.7563V5.59998",
			stroke: "currentColor",
			strokeWidth: 1.29,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgReferenceMaterialIcon;
